module.exports = __webpack_public_path__ + "img/share-icon.3a238cbc.svg";